export default {
  id: 'locator.equipmentId',
  name: 'locator.equipmentId',
  displayName: 'Go To Equipment',
  valueType: 'string',
  objectType: 'locator',
  get: obj => {
    const equipmentId = obj?.data?.asset?.id;
    return equipmentId || null;
  }
};